import React, { useRef } from 'react'
import { VideoJsPlayer, VideoJsPlayerOptions } from 'video.js'
import Box from '@components/Box'
import PlayIcon from '@icons/playIcon.svg'
import { ILink } from './types'
import VideoJS from './VideoJS'
import styled from 'styled-components'

const SVideoBox = styled(Box)`
  .vjs-theme-forest .vjs-big-play-button {
    background: url(${PlayIcon});
  }
`

const VideoPlayer: React.FC<ILink> = ({ link }) => {
  const playerRef = useRef<VideoJsPlayer | null>(null)

  const videoJsOptions: VideoJsPlayerOptions = {
    autoplay: false,
    controls: true,
    fluid: true,
    sources: [
      {
        src: link,
        type: 'video/mp4',
      },
    ],
  }

  const handlePlayerReady = (player: VideoJsPlayer) => {
    player.on(player, 'ended', () => {
      player.currentTime(0)
    })
    playerRef.current = player
  }

  return (
    <SVideoBox width="100%" maxWidth="560px" data-vjs-player>
      {link && <VideoJS options={videoJsOptions} onReady={handlePlayerReady} />}
    </SVideoBox>
  )
}
export default VideoPlayer
